export default __webpack_public_path__ + "static/diferencial-img-2-0df620286943c3017d235123cb38933a.png";